import {
  CONTEXT_VALUE_INDICATOR_X_OFFSET,
  CONTEXT_VALUE_SIGN_NUDGE_RIGHT,
} from '../constants.js';
import { SparklineContainerHeight } from '../types/sparkline-container-height.js';

export interface ContextValuePositions {
  signXOffset: number;
  textXOffset: number;
}

export const getContextValueXOffset = (
  isLeft: boolean,
  chartLeftOffset: number,
  labelWidth: number,
  dottedLineWidth: number,
  containerHeight: SparklineContainerHeight,
  isSmallFontSize: boolean,
): ContextValuePositions => {
  // Sign glyph width: 4 px (HEIGHT24) or 6 px (larger containers).
  const signWidth =
    containerHeight === SparklineContainerHeight.HEIGHT24 ? 4 : 6;
  // Pixel adjustments that align sign/text relative to the label edge per font size.
  const signMarginAdjustment = isSmallFontSize ? 1 : 10;
  const textMarginAdjustment = isSmallFontSize ? 7 : 0;

  if (isLeft) {
    const base =
      chartLeftOffset -
      labelWidth -
      CONTEXT_VALUE_INDICATOR_X_OFFSET +
      signWidth;
    return {
      signXOffset: base - signMarginAdjustment,
      textXOffset: base + textMarginAdjustment,
    };
  }

  // Right-positioned: offsets are relative to the dotted line end.
  const textXOffset = dottedLineWidth + CONTEXT_VALUE_INDICATOR_X_OFFSET;
  const signXOffset = textXOffset - signWidth - CONTEXT_VALUE_SIGN_NUDGE_RIGHT;

  return { signXOffset, textXOffset };
};
